import { render, staticRenderFns } from "./LoginSignUpModal.vue?vue&type=template&id=4581eb04&"
import script from "./LoginSignUpModal.vue?vue&type=script&lang=ts&"
export * from "./LoginSignUpModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports